import React, { useLayoutEffect, useRef } from 'react';
import gsap from 'gsap';
import ThronAudio from '@components/utils/ThronAudio';
const wrapperStyle = {
    position: 'relative',
    height: '2.8rem',
    width: '18rem',
};
const waveStyle = {
    position: 'absolute',
    left: 0,
    top: 0,
    width: '100%',
    height: '100%',
};
const ThronAudioSoundwave = (props) => {
    const renderWave = () => (React.createElement("svg", { width: "180", height: "30", viewBox: "0 0 180 30", fill: "none", xmlns: "http://www.w3.org/2000/svg" },
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M5 18.5L5 11.5H4L4 18.5H5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M13.5 6L13.5 24H12.5L12.5 6H13.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M22 0.5L22 29.5H21L21 0.5L22 0.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M30.5 3.5L30.5 26.5H29.5L29.5 3.5H30.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M38.5 9V21H37.5V9H38.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M47 3.5V26.5H46V3.5H47Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M56 21.5V8.5H55V21.5H56Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M65 26.5V3.5L64 3.5V26.5H65Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M73.5 6V24H72.5V6H73.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M82 0.5V29.5H81V0.5L82 0.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M90.5 0.5V29.5H89.5V0.5L90.5 0.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M99 9V21H98V9H99Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M107.5 3.5V26.5H106.5V3.5H107.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M116 21.5V8.5H115V21.5H116Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M125 20.5V9.5H124V20.5H125Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M133.5 6V24H132.5V6H133.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M142 0.5V29.5H141V0.5L142 0.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M150.5 3.5V26.5H149.5V3.5H150.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M159 9V21H158V9H159Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M167.5 3.5V26.5H166.5V3.5H167.5Z", fill: "white" }),
        React.createElement("path", { fillRule: "evenodd", clipRule: "evenodd", d: "M176 21.5V8.5H175V21.5H176Z", fill: "white" })));
    const currentRef = useRef(null);
    useLayoutEffect(() => {
        if (currentRef.current) {
            const tl = gsap.timeline({ paused: true });
            tl.fromTo(currentRef.current, {
                clipPath: 'polygon(0 0, 0 0, 0 100%, 0 100%)',
                ease: 'linear',
            }, {
                clipPath: 'polygon(0 0, 100% 0, 100% 100%, 0% 100%)',
                ease: 'linear',
            });
            tl.progress(props.progress);
        }
    }, [props.progress]);
    return (React.createElement("div", { className: "soundwave-icon--wrapper", style: wrapperStyle },
        React.createElement("div", { className: "soundwave-icon-current", ref: currentRef, style: waveStyle }, renderWave()),
        React.createElement("div", { className: "soundwave-icon-total", style: Object.assign(Object.assign({}, waveStyle), { opacity: 0.4 }) }, renderWave()),
        React.createElement(ThronAudio, { autoplay: false, loop: true, 
            // muted
            thronID: props.thronID, onPauseCallback: props.onPauseCallback, onPlayCallback: props.onPlayCallback, onCompleteCallback: props.onCompleteCallback, onInitCallback: props.onInitCallback, onTimeUpdate: props.onTimeUpdate, noskin: true })));
};
export default ThronAudioSoundwave;
